import { abyssColors, primary } from '@/theme/colors';
import { TextField, alpha, styled as muiStyled } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

export const paperStyles = {
  maxWidth: '47.2rem',
  borderRadius: '0.8rem',
  border: `0.1rem solid ${abyssColors.primary[200]}`,
};

export const titleStyles = {
  padding: '2.4rem',
  paddingBottom: '1.6rem',
  typography: 'h4',
};

export const contentStyles = {
  padding: '2.4rem',
  paddingTop: '0',
};

export const radioButtonStyles = {
  width: '100%',
  '& .MuiSvgIcon-root': {
    color: primary.LightBlue,
  },
};

const border = `0.1rem solid ${alpha(abyssColors.primary[700], 0.5)}`;

const commonStyles = {
  '& fieldset': {
    borderColor: `${alpha(abyssColors.primary[700], 0.5)}`,
    borderRadius: '0px',
    border: 0,
    borderBottom: '0.1rem solid',
  },
  '& .MuiInput-underline:after': {
    borderBottom: border,
  },
  '& .MuiFilledInput-underline:after': {
    borderBottom: border,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderBottom: border,
      borderColor: alpha(abyssColors.primary[700], 0.5),
    },
  },
  '& .MuiInputBase-root:after': {
    borderBottom: border,
  },
};

export const autocompleteTextFieldStyles = {
  '& label': {
    color: abyssColors.primary[300],
  },
  ...commonStyles,
};

export const ReportFormTextField = muiStyled(TextField)(() => ({
  '& label': {
    color: `${abyssColors.primary[300]} !important`,
  },
  '& .MuiSvgIcon-root': {
    color: `${abyssColors.primary[300]} !important`,
    fontSize: '1.4rem',
    display: 'none',
  },
  '& .MuiInputLabel-shrink .MuiSvgIcon-root': {
    display: 'block',
  },
  ...commonStyles,
}));

export const ReportDatePicker = muiStyled(DatePicker)(() => ({
  ...commonStyles,
  '& input': {
    paddingLeft: '0px !important',
    fontSize: '1.6rem',
    color: abyssColors.primary[500],
  },
  '& img': {
    height: '20px !important',
  },
  '& label': {
    marginLeft: '-14px',
    color: '#A3A3A3 !important',
  },
  '& .MuiInputBase-root ': {
    paddingLeft: '0px',
    paddingRight: '0px',
  },
}));

export const actionsStyles = {
  borderTop: `0.1rem solid ${abyssColors.primary[100]}`,
  padding: '1.2rem 2.4rem',
  gap: '1.6rem',
  button: {
    margin: '0 !important',
  },
};
